module.exports = __webpack_public_path__ + "img/Frequency24GHzV2.861c326e.svg";